// Rendered at the end of <body>, Radix's popups inherited the body's
// inherited properties; in place they would take those of whatever holds them.
const BODY_INHERITED_STYLES = [
   'font-family',
   'font-size',
   'font-weight',
   'font-style',
   'font-stretch',
   'font-variant-caps',
   'font-variant-ligatures',
   'font-variant-numeric',
   'font-feature-settings',
   'font-variation-settings',
   'font-kerning',
   'letter-spacing',
   'word-spacing',
   'text-transform',
   'text-align',
   'text-align-last',
   'text-indent',
   'text-shadow',
   'text-rendering',
   'white-space',
   'text-wrap-style',
   'word-break',
   'overflow-wrap',
   'hyphens',
   'tab-size',
   'list-style-type',
   'list-style-position',
   'list-style-image',
   'direction',
   'cursor',
   'caret-color',
   'fill',
   'stroke',
   '-webkit-font-smoothing',
];

export function takeBodyStyles(element: HTMLElement) {
   const body = getComputedStyle(document.body);
   for (const property of BODY_INHERITED_STYLES) {
      element.style.setProperty(property, body.getPropertyValue(property));
   }
   element.style.lineHeight = bodyLineHeight(body.lineHeight);
}

// A unitless line-height scales with each descendant's font size, but reads
// back in pixels; a probe with another font size tells the two apart.
function bodyLineHeight(resolved: string) {
   const probe = document.createElement('div');
   probe.style.fontSize = '100px';
   document.body.append(probe);
   const probed = getComputedStyle(probe).lineHeight;
   probe.remove();
   if (probed === 'normal' || probed === resolved) return probed;
   return String(Number.parseFloat(probed) / 100);
}
